import * as React from 'react';
export const IcRocket = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4.14 16.14a1 1 0 00-1.65.39l-.27.81a.5.5 0 00.47.66H4l-1.33 2.66a.5.5 0 00.67.67L6 20v1.31a.5.5 0 00.66.47l.8-.27a1 1 0 00.4-1.65l-3.72-3.72zm16.17-14A20.18 20.18 0 0010.88 5H7.24a2 2 0 00-1.79 1.11l-2.73 5.44a1 1 0 00.9 1.45h1.57c-.06.33-.12.65-.15 1a2.05 2.05 0 00.58 1.63l2.76 2.76A2.05 2.05 0 0010 19c.34 0 .66-.09 1-.14v1.56a1 1 0 001.45.9l5.44-2.73A2 2 0 0019 16.76v-3.6a20.119 20.119 0 002.92-9.47 1.52 1.52 0 00-1.61-1.6v.05zM12 14a2 2 0 110-4 2 2 0 010 4z'
      fill='currentColor'
    />
  </svg>
);
